
<div class="file-uploader">
  <!-- selector -->
  <div *ngIf="isEditable" class="file-uploader__file-selector">
    <input type="file"
           matInput
           (change)="onFileChanged($any($event.currentTarget).files)"
           multiple
           hidden
           #fileUpload>

    <button (click)="fileUpload.click()" mat-raised-button color="primary">
      <mat-icon>cloud_upload</mat-icon>
      {{label}}
      <span class="sc-required sc-required-star" *ngIf="required"></span>
    </button>
  </div>

  <!-- current file (already from init + selected) -->
  <div *ngFor="let file of files" class="file-uploader__file-item">
    <div class="file-uploader__file-item__content">
      <span *ngIf="file.isWaiting">Please wait...</span>

      <div class="file-uploader__file-item__content__file-icon">
        <mat-icon>attach_file</mat-icon>
      </div>

      <div class="file-uploader__file-item__content__info">
        <!-- file name + size -->
        <p *ngIf="file.fileName" class="file-uploader__file-item__content__info__file-name">{{ file.fileName }}</p>
        <p *ngIf="file.fileSize" class="file-uploader__file-item__content__info__file-size">{{ (file.fileSize / 1024 / 1024).toFixed(2) }} MB</p>
      </div>

      <!-- download button -->
      <a [href]="file.downloadUrl" *ngIf="file.downloadUrl && !file.isUploading" download target="_self" mat-icon-button>
        <mat-icon>download</mat-icon>
      </a>

      <!-- remove file -->
      <button mat-icon-button
              *ngIf="isEditable && !file.isUploading && !file.isWaiting"
              (click)="onRemoveFile(file)">
        <mat-icon>delete_forever</mat-icon>
      </button>
    </div>

    <!-- upload progress -->
    <div class="file-uploader__upload-progress" *ngIf="file.isUploading">
      <div class="file-uploader__upload-progress__progress-percentage">
        Uploading...{{ file.uploadedPercentage + '%' }}
        <mat-progress-bar mode="determinate"
                          [value]="file.uploadedPercentage"></mat-progress-bar>
      </div>

      <button mat-icon-button (click)="onCancelUpload(file)">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
  </div>
</div>
